var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoverageactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 30.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9136"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8698",
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6607",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5530",
    d: "M15.25 16v4.5a1.5 1.5 0 003 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5531",
    d: "M15.25 10V8.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5532",
    d: "M8.5 16H22a6.994 6.994 0 00-2.291-4.283A6.5 6.5 0 0015.25 10a6.5 6.5 0 00-4.46 1.717A6.994 6.994 0 008.5 16z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5533",
    d: "M6.25 6.25h18v18h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7329",
    d: "M15.25 29.75h0a14.5 14.5 0 01-14.5-14.5h0A14.5 14.5 0 0115.25.75h0a14.5 14.5 0 0114.5 14.5h0a14.5 14.5 0 01-14.5 14.5z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}

export default SvgCoverageactive;


//////////////////
// WEBPACK FOOTER
// ./src/icons/coverage active.svg
// module id = 793
// module chunks = 101